export default __webpack_public_path__ + "static/media/upcoming_card.627443e0.png";